<template>
  <div>
    <div class="pa-2">
      <RegisterUser
        v-bind:dialogRegister="dialogRegister"
        @close="closeDialog"
      />
    </div>

    <div class="pa-3">
      <v-btn
        block
        dark
        rounded
        depressed
        color="#1E656C"
        @click="dialogRegister = true"
        ><v-icon class="mr-2">mdi-file-download</v-icon> Unduh Hasil</v-btn
      >
      <v-btn
        block
        rounded
        color="#1E656C"
        depressed
        outlined
        class="mt-2 text-capitalize"
        to="/journey/roadmap"
        >Back to Journey</v-btn
      >
    </div>
    <div class="temp_ad purple-bg">
      <section class="txt white--text pa-3 d-flex align-center">
        <div>
          <h3>
            Mulai Kenali dan Kembangkan Dirimu, <br />
            Unduh Aplikasi <b>Teman</b> Bakat Sekarang!
          </h3>
          <div>
            <a
              href="https://play.google.com/store/apps/details?id=com.temanbakat"
              target="_blank"
              style="text-decoration: none"
            >
              <img
                src="../../assets/img/Googleplay-button0.png"
                height="40px"
                alt=""
              />
            </a>
          </div>
        </div>
      </section>
      <div class="temp_img d-flex justify-end">
        <img
          src="../../assets/img/V.1 290821 Temanbakat.id - Ilsutrasi 50.png"
          height="200px"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import RegisterUser from "../journey/Modal/RegisterUser.vue";
export default {
  components: { RegisterUser },
  data() {
    return {
      dialogRegister: false,
    };
  },
  methods: {
    closeDialog() {
      this.dialogRegister = false;
    },
  },
};
</script>

<style scoped>
.temp_ad {
  position: relative;
}
.txt {
  position: absolute;
  width: 70%;
}
.temp_img {
  width: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
}
</style>
